module.exports = require("./NavBarItem.vue");